import { useEffect, useState } from "react";
import api from "../api";
import { Spinner } from "../components/Logo";
import { PageHeader, EmptyState, StatusChip } from "../components/ui";
import { Award, Download, ShieldCheck, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function Certificates() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/certificates/mine").then((r) => setData(r.data.certificates)).catch(() => {});
  }, []);

  const download = async (id, vid) => {
    try {
      const res = await api.get(`/certificates/${id}/download`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = `certificate-${vid}.pdf`; a.click();
      window.URL.revokeObjectURL(url);
    } catch { toast.error("Could not download certificate"); }
  };

  return (
    <div data-testid="certificates-page">
      <PageHeader overline="Achievements" title="My certificates" desc="Complete a full learning path to earn a verifiable certificate of completion." />

      {!data ? <Spinner /> : data.length === 0 ? (
        <EmptyState icon={Award} title="No certificates yet" desc="Finish every module in a learning path to unlock your first certificate." />
      ) : (
        <div className="grid sm:grid-cols-2 gap-5">
          {data.map((c) => (
            <div key={c.id} className="card p-6 relative overflow-hidden" data-testid={`cert-${c.id}`}>
              <div className="absolute inset-0 grid-bg opacity-20" />
              <div className="relative">
                <div className="flex items-start justify-between">
                  <Award className="text-[#F26522]" size={36} />
                  <StatusChip status={c.status} />
                </div>
                <h3 className="font-heading font-semibold text-lg mt-4">{c.title}</h3>
                <p className="text-slate-400 text-sm mt-1">Issued {new Date(c.issued_at).toLocaleDateString()}</p>
                <p className="text-xs text-slate-500 font-mono mt-2">ID: {c.verification_id}</p>
                <div className="flex items-center gap-2 mt-5">
                  <button className="btn-primary text-sm" onClick={() => download(c.id, c.verification_id)} disabled={c.status !== "valid"} data-testid={`cert-download-${c.id}`}>
                    <Download size={15} /> Download PDF
                  </button>
                  <a className="btn-secondary text-sm" href={`/verify/${c.verification_id}`} target="_blank" rel="noreferrer" data-testid={`cert-verify-${c.id}`}>
                    <ShieldCheck size={15} /> Verify <ExternalLink size={13} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
